import { IGuaranteeProps } from "../../../Interfaces/IGuaranteeProps";
import { GuaranteeColumns } from "../../../Static/AnalysisColumns";
import CustomTableComponent from "../../Shared/CustomTable";

interface IGuaranteesComponentProps {
    rowGuarantees: IGuaranteeProps[], 
    percentage: number
}

const GuaranteesComponent = (props: IGuaranteesComponentProps) => {
    GuaranteeColumns[2].name = (props.percentage*100)+"% " + GuaranteeColumns[2].name.slice(4);
    return (
        <div className='pagination-tab-body d-flex flex-column mb-2 mt-3'>
            <span className='text-center mb-2'><b>Garantias:</b></span>
            <CustomTableComponent
                rows={props.rowGuarantees}
                hasHeader={false}
                columns={GuaranteeColumns}
                isTableInverted={true}
            />
        </div>
    )
}

export default GuaranteesComponent;